import { parsePhoneNumber } from "libphonenumber-js";

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export const removeAllNonNumbers = (string, keepPlusSign = false) => {
  if (keepPlusSign) {
    return `+${string.replace(/\D/g, "")}`;
  } else {
    return `${string.replace(/\D/g, "")}`;
  }
};

export const getCountryCode = (number, defaultCountryCode) => {
  try {
    return parsePhoneNumber(number).countryCallingCode;
  } catch {
    console.log("invalid number, using default country code");
    return defaultCountryCode || "1";
  }
};

export const mergeDaysWithSameHours = (schedule) => {
  let result = [];
  let i = 0;

  while (i < schedule.length) {
    let current = schedule[i];
    let startDay = current.day;
    let endDay = current.day;
    let opensAt = current.opens_at;
    let closesAt = current.closes_at;

    while (
      i + 1 < schedule.length &&
      schedule[i + 1].opens_at === opensAt &&
      schedule[i + 1].closes_at === closesAt
    ) {
      endDay = schedule[i + 1].day;
      i++;
    }

    if (startDay === endDay) {
      result.push({
        day: startDay,
        opens_at: opensAt,
        closes_at: closesAt,
        opened: current.opened,
      });
    } else {
      result.push({
        day: `${startDay} to ${endDay}`,
        opens_at: opensAt,
        closes_at: closesAt,
        opened: current.opened,
      });
    }
    i++;
  }

  return result;
};
export const pubnubCleanUp = (pubnub, listeners) => {
  // console.log("cleanup function called");
  pubnub.removeListener(listeners);
  pubnub.unsubscribeAll();
};
export const isOnlyWhiteSpace = (str) => {
  return /^\s*$/.test(str);
};

export function isColorDark(hex) {
  hex = hex.replace("#", "");

  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((c) => c + c)
      .join("");
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

  return luminance < 128;
}
